import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../assets/dzears.png";

const links = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  const isActive = (to) => (to === "/" ? pathname === "/" : pathname.startsWith(to));

  return (
    <>
      {/* Desktop sidebar */}
      <nav className="hidden md:flex fixed top-0 left-0 h-full w-28 flex-col items-center justify-between border-r border-gray-100 py-8 bg-white z-50">
        <Link to="/">
          <img
            src={logo}
            alt="Logo"
            className="h-9 w-auto hover:opacity-60 transition-opacity duration-200"
          />
        </Link>

        <ul className="flex flex-col items-center gap-7">
          {links.map(({ to, label }) => (
            <li key={to} className="relative flex items-center">
              {isActive(to) && (
                <span className="absolute -left-4 top-1/2 -translate-y-1/2 h-3.5 w-[2px] bg-black rounded-full" />
              )}
              <Link
                to={to}
                className={`text-sm tracking-wide transition-colors duration-200 ${
                  isActive(to) ? "text-black font-semibold" : "text-gray-400 hover:text-black"
                }`}
              >
                {label}
              </Link>
            </li>
          ))}
        </ul>

        <span className="h-6 w-6" />
      </nav>

      {/* Mobile top bar */}
      <header className="md:hidden fixed top-0 left-0 right-0 flex items-center justify-between bg-white/95 backdrop-blur-sm border-b border-gray-100 px-5 py-4 z-50">
        <Link to="/" onClick={() => setOpen(false)}>
          <img src={logo} alt="Logo" className="h-8 w-auto" />
        </Link>

        <button
          onClick={() => setOpen(!open)}
          className="flex flex-col justify-center items-center w-8 h-8 gap-[5px]"
          aria-label="Toggle menu"
        >
          <span className={`block h-[1.5px] w-5 bg-black transition-all duration-300 origin-center ${open ? "rotate-45 translate-y-[6.5px]" : ""}`} />
          <span className={`block h-[1.5px] w-5 bg-black transition-all duration-300 ${open ? "opacity-0" : ""}`} />
          <span className={`block h-[1.5px] w-5 bg-black transition-all duration-300 origin-center ${open ? "-rotate-45 -translate-y-[6.5px]" : ""}`} />
        </button>
      </header>

      {/* Mobile dropdown */}
      <div
        className={`md:hidden fixed top-[57px] left-0 right-0 bg-white border-b border-gray-100 z-40 transition-all duration-200 ${
          open ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-1 pointer-events-none"
        }`}
      >
        <ul className="flex flex-col py-1">
          {links.map(({ to, label }) => (
            <li key={to}>
              <Link
                to={to}
                onClick={() => setOpen(false)}
                className={`block px-5 py-3 text-sm transition-colors duration-150 ${
                  isActive(to) ? "text-black font-semibold" : "text-gray-400 hover:text-black"
                }`}
              >
                {label}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
}
